import { EmailAddress, Nullable } from './utils';

import Auth from 'businessLogic/Auth';
import Chat from 'businessLogic/Chat/Chat';
import IXP from 'businessLogic/IXP';
import Insight from 'businessLogic/Insight';
import Payment from 'businessLogic/Payment';
import Sale from 'businessLogic/Sale';
import Wallet from 'businessLogic/Wallet';

export interface IBusinessLogic {
  auth: Auth;
  insight: Insight;
  sale: Sale;
  wallet: Wallet;
  payment: Payment;
  ixp: IXP;
  chat: Chat;
}

export interface PayPalOrderIds {
  orderID: string;
  payerID: string;
  orderId: string;
  notAllowedPayPalCardPayment: boolean;
  liabilityShifted?: boolean;
}

export interface invoiceInfo {
  ssrtid: string;
  companyLocale: string;
  token: string;
  ppCaptureOrderKey?: string;
}
export interface paypalOrderData {
  payment: {
    method: string;
    amount: string;
    gratuityAmount?: number;
    currencyCode: string;
    additionalPayorRecipient?: string;
  };
  risk: {
    profileToken: string;
  };
  sale: {
    type: string;
    isGpu: boolean;
    subType?: string | null;
  };
  contact?: {
    name?: string;
    emails?: readonly EmailAddress[];
  };
}
export interface pbbOrderData {
  payment: {
    method: string;
    amount: string;
    currencyCode: string;
  };
  sale: {
    type: string;
    isGpu: boolean;
  };
  payByBankDetail: {
    issuerBankId: string;
    issuerBankName: string;
    payorName?: string;
    payorEmailAddress?: string;
    country?: string;
  };
  contact: {
    name: string;
    emails: EmailAddress[];
  };
  risk: {
    profileToken: Nullable<string>;
  };
}

export interface handlePbbResponse {
  data: {
    orderId: string;
    status: string;
    payByBankRedirectUrl: string;
  };
}
export interface PbcWalletInfo {
  walletId?: string;
  cvc?: string;
  walletToken?: string;
}

export interface BrowserInfo {
  userAgent: string;
  acceptHeader: string;
  language: string;
  colorDepth: number;
  screenHeight: number;
  screenWidth: number;
  timeZoneOffset: number;
  javaEnabled: boolean;
  javaScriptEnabled: boolean;
}

export interface PaymentOrderData {
  payment: {
    method: 'PAYBYBANK' | 'PAYBYCARD' | 'PAYBYCARD_WALLET';
    amount: string;
    currencyCode: string;
  };
  sale: {
    type: string;
    isGpu: boolean;
  };
  contact: {
    emails: string[];
  };
  risk: {
    profileToken: string | null;
  };
  creditCardDetail?: {
    walletInfo: PbcWalletInfo;
    country: string;
    payorName: string;
    browserInfo: BrowserInfo;
    isSavePaymentMethodChecked: boolean;
    entityId: string;
    ticket: string;
  };
  payByBankDetail?: {
    issuerBankId: string;
    issuerBankName: string;
    payorName: string;
    payorEmailAddress: string;
    country: string;
  };
}

export interface PaymentOrderResponse {
  data: {
    orderId: string;
    status: string;
    payByBankRedirectUrl?: string;
    payByCardResponse?: {
      redirectUrl?: string;
      paymentResponse?: {
        paymentStatus: string;
        paymentMethod: string;
        trackingId: string;
        amountPaid: number;
        paymentDate: number;
        authorizationCode: string;
        walletId?: string;
      };
    };
  };
}

export enum AdyenPaymentMethod {
  PAYBYBANK = 'PAYBYBANK',
  PAYBYCARD = 'PAYBYCARD',
  PAYBYCARD_WALLET = 'PAYBYCARD_WALLET',
}
